import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({

    theme: {
        options: {
            customProperties: true,
        },
        themes: {
            light: {
                primary: '#ee44aa',
                secondary: '#424242',
                accent: '#82B1FF',
                error: '#FF5252',
                info: '#2196F3',
                success: '#4CAF50',
                warning: '#FFC107',
                similiaverde: '#2cbca4',
                similiaazul: '#5ca0eb',
                similiaamarillo: '#d9b836',
                tiendasimilia: '#51CFB2',
                verdeclarito: '#9af5d1',
                titulososcuro: '#04746D',
                titulosclarito: '#F8E9AE',
                ayurveda1: '#9dcc94',
                ayurveda2: '#fbc684',
                magistrales1: '#f7b5a7',
                magistrales2: '#ef7b6d',
                homeo1: '#07ae93',
                homeo2: '#00746e',
                probioticos1: '#6d81af',
                probioticos2: '#7b5da4',
                verdewhatsapp: '#00bb2d',
               
            },
        },
    },
});